<template>
<label data-v-b97eb8f0="" role="switch" aria-checked="true" :class="{'is-checked': value}" class="el-switch">
  <input type="checkbox" name="" :checked="value" true-value="true" class="el-switch__input" @change="onChanged">
  <span class="el-switch__core" style="width: 40px;"></span>
</label>
</template>

<script>
export default {
  name: 'MySwitch',
  props: {
    value: {
      type: Boolean
    }
  },
  methods: {
    onChanged () {
      let {value} = this
      value = !value
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/MySwitch.vue